<template>
  <div id="container" style="height: 100%; overflow: hidden;">
    <el-container class="main-con" style="height: 100%">
      <el-main style="height: 100%;overflow: hidden;">
        <!--顶部header-->
        <el-row style="height: 7%">

          <!-- 桌面端顶部导航 -->
          <el-col :span="isCollapse ? 1 : 3" v-if="!isMobile()">
            <div class="grid-content bg-purple">
              <el-link href="/home" target="_self" class="logo" :underline="false" v-if="!isCollapse">
                <b><span>数字</span>资源库</b>
              </el-link>
              <el-tooltip class="item" effect="dark" :content="alertText" placement="right">
                <el-button class="fold-icon" @click="toggleCollapse" plain
                           style="width: 36px; height: 36px; font-size: 22px;">
                  <i v-if="isCollapse" class="el-icon-s-unfold"></i>
                  <i v-if="!isCollapse" class="el-icon-s-fold"></i>
                </el-button>
              </el-tooltip>
            </div>
          </el-col>
          <el-col :span="(!isMobile() ? (isCollapse ? 23 : 21) : 24)" v-if="!isMobile()">
            <el-header style="text-align: left; font-size: 12px">
              <div class="header-right">
                <span v-if="!isMobile()">{{ successInfo.workName }}</span>
                <el-dropdown @command="handleCommand" class="avatar-dropdown">
                  <el-avatar size="medium" style="cursor: pointer;">
                    {{ getFirstName() }}
                  </el-avatar>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="logout" icon="el-icon-circle-close">退出登录</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </el-header>
          </el-col>
        </el-row>

        <!--下部内容区域-->
        <el-row style="height: 93%">

          <!--桌面端左侧菜单栏-->
          <el-col :span="isCollapse ? 1 : 3" style="height: 100%;" v-if="!isMobile()">
            <el-aside width="100%" style="background-color: rgb(255,255,255); height: 100%; overflow-x: hidden;">
              <el-menu
                  :default-active="$route.path"
                  :router="true"
                  style="border-right: 0;"
                  class="el-menu-vertical-demo"
                  :collapse="isCollapse"
                  :collapse-transition="false"
              >
                <template v-for="menuItem in menuList">
                  <el-menu-item
                      :index="menuItem.index"
                      v-if="!menuItem.children"
                  >
                    <i :class="menuItem.icon"></i>
                    <span slot="title">{{ menuItem.title }}</span>
                  </el-menu-item>
                  <el-submenu
                      :index="menuItem.index"
                  >
                    <template slot="title">
                      <i :class="menuItem.icon"></i>
                      <span slot="title">{{ menuItem.title }}</span>
                    </template>
                    <template v-for="group in menuItem.children">
                      <el-menu-item-group>
                        <el-menu-item
                            :index="item.index"
                            v-for="item in group.items"
                            :key="item.index"
                        >
                          {{ item.title }}
                        </el-menu-item>
                      </el-menu-item-group>
                    </template>
                  </el-submenu>
                </template>
              </el-menu>
            </el-aside>
          </el-col>

          <!--右侧主内容区域-->
          <el-col
              :span="(!isMobile() ? (isCollapse ? 23 : 21) : 24)"
              style="height: 100%;"
              :class="{ 'mobile-content': isMobile() }"
          >
            <el-container class="right-main-con">
              <el-main style="position: relative">
                <router-view></router-view>
              </el-main>
            </el-container>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import { setLocal, getLocal, checkLocal } from '@/utils/localstorage.js';

export default {
  name: 'HomeView',
  data() {
    return {
      alertText: '收起',
      isCollapse: false,
      searchInput: '',
      select: '',
      search: {
        size: 1000,
        current: 1
      },
      successInfo: {},
      systemMes: 12,
      letterMes: 0,
      commentMes: 4,
      systems: [],
      showMobileMenu: false, // 移动端菜单显示状态
      menuList: [
        {
          index: '/infoManagement',
          icon: 'el-icon-document-copy',
          title: '信息管理',
          children: [
            {
              items: [
                {
                  index: '/infoManagement/informationEntry',
                  title: '信息录入',
                },
                {
                  index: '/infoManagement/informationEdit',
                  title: '信息编辑',
                }
              ]
            }
          ]
        },
        {
          index: '/approveManagement',
          icon: 'el-icon-s-claim',
          title: '审核管理',
          children: [
            {
              items: [
                {
                  index: '/approveManagement/pendingApprovalList',
                  title: '审核信息',
                }
              ]
            }
          ]
        }
      ]
    };
  },
  mounted() {
    // 监听窗口大小变化，动态调整布局
    window.addEventListener('resize', this.handleResize);
    const userInfo = window.localStorage.getItem("successInfo");
    this.successInfo = JSON.parse(userInfo);
    checkLocal();
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    // 获取姓氏
    getFirstName() {
      if (!this.successInfo.workName) return '';
      return this.successInfo.workName.charAt(0);
    },
    // 判断是否是手机端
    isMobile() {
      // 更精确的移动设备检测，考虑屏幕宽度
      return window.innerWidth < 768 || /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent);
    },

    //下拉框 - 退出
    handleCommand(command) {
      if (command === 'logout') {
        this.$router.push({path: '/'});
        this.$message.success('退出成功');
      }
    },
    toggleCollapse() {
      this.isCollapse = !this.isCollapse;
      this.alertText = this.isCollapse ? '展开' : '收起';
    },
    // 窗口大小变化处理
    handleResize() {
      // 在桌面/移动设备切换时重置相关状态
      if (this.isMobile() && !this.isMobile()) {
        this.showMobileMenu = false;
      }
    },
    // 移动端菜单选择后关闭菜单
    handleMenuSelect() {
      if (this.isMobile()) {
        this.showMobileMenu = false;
      }
    },
    // 移动端子菜单选择后关闭菜单
    handleSubMenuSelect() {
      if (this.isMobile()) {
        this.showMobileMenu = false;
      }
    }
  },
  watch: {
    // 监听路由变化，在移动端自动关闭菜单
    $route() {
      if (this.isMobile() && this.showMobileMenu) {
        this.showMobileMenu = false;
      }
    }
  }
};
</script>

<style scoped>
#container {
  height: 100%;
  overflow: hidden;
}

.item {
  margin: 4px;
}

.item-badge {
  margin-top: 10px;
  margin-right: 40px;
}

.item-mes-badge {
  margin-top: 10px;
}

.message-button {
  font-size: 26px;
  width: 30px;
  padding: 0;
  margin: 0 15px 0 12px;
  border: 0;
  background: rgba(255, 255, 255, 0);
  position: relative;
}

.message-button:hover {
  background: rgba(255, 255, 255, 0);
}

.notice-dropdown >>> .el-badge .el-badge__content.is-fixed.is-dot {
  right: -15px;
  top: 12px;
}

.main-con-con {
  height: 500px;
  border: 1px solid #eee;
}

.el-main {
  padding: 0;
}

.bg-purple {
  background: #ffffff;
}

.grid-content {
  height: 60px;
  min-height: 36px;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
}

.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}

.el-header {
  background-color: rgb(242, 244, 245);
  color: #333;
  line-height: 60px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.header-right {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: auto;
  padding-right: 20px;
}

.header-right span {
  margin-right: 15px;
  white-space: nowrap;
}

.el-avatar {
  background: #5799fb;
  color: white;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
}

.home-search >>> .el-textarea__inner, .el-input__inner {
  color: #505458;
}

.home-search >>> input::-webkit-input-placeholder {
  color: #505458;
}

.home-search >>> input::-moz-placeholder {
  color: #505458;
}

.home-search >>> input::-moz-placeholder {
  color: #505458;
}

.home-search >>> input::-ms-input-placeholder {
  color: #505458;
}

.el-dropdown {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.el-dropdown-menu >>> .el-badge__content {
  max-width: 20px;
  min-width: 14px;
  font-size: 7px;
  height: 14px;
  line-height: 14px;
  padding: 0 4px;
  background: rgba(240, 36, 36, 0.8);
}

.el-dropdown-menu >>> .el-badge__content.is-fixed {
  position: absolute;
  top: 8px;
  right: 8px;
}

.notice-dropdown {
  width: 58px;
  height: 36px;
}

.avatar-dropdown {
  width: 68px;
  height: 36px;
}

.el-aside {
  color: #333;
}

.logo {
  font-size: 1.5rem;
  color: #333;
  text-transform: uppercase;
}

.logo b {
  font-weight: 900;
  padding-left: 10px;
}

.logo:hover, .logo:focus {
  text-decoration: none;
  outline: none;
}

.logo span {
  color: #5799fb;
}

.fold-icon {
  background-color: #fbfbfb;
  border-radius: 5px;
  border: 1px solid #eaeaea;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.fold-icon:hover {
  box-shadow: 0 0 6px 1px rgba(0, 0, 0, 0.4);
}

.input-with-select .el-input-group__prepend {
  background-color: #fff;
}

.el-input-group__append button.el-button,
.el-input-group__append div.el-select .el-input__inner,
.el-input-group__append div.el-select:hover .el-input__inner,
.el-input-group__prepend button.el-button,
.el-input-group__prepend div.el-select .el-input__inner,
.el-input-group__prepend div.el-select:hover .el-input__inner {
  color: #3e4144;
  font-size: 20px;
}

.right-main-con {
  height: 100%;
  overflow-y: auto;
}

/* 移动端样式 */
.mobile-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 100%;
}

.mobile-menu-btn {
  font-size: 18px;
}

.mobile-logo {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  flex: 1;
  text-align: center;
}

.mobile-logo span {
  color: #5799fb;
}

.mobile-header-right {
  display: flex;
  align-items: center;
}

/* 移动端侧边栏 */
.mobile-sidebar-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  transition: opacity 0.3s ease;
}

.mobile-sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 260px;
  height: 100%;
  background-color: #fff;
  z-index: 1001;
  transition: transform 0.3s ease;
  overflow-y: auto;
  padding-top: 60px; /* 与头部高度一致 */
}

/* 移动端内容区域 */
.mobile-content {
  padding: 10px;
  box-sizing: border-box;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .el-menu-vertical-demo {
    width: 100%;
  }

  .el-header {
    padding: 0 15px;
  }

  .header-right span {
    display: none; /* 在小屏幕上隐藏用户名 */
  }
}

/* 平板设备适配 */
@media (min-width: 768px) and (max-width: 1024px) {
  .el-col {
    min-width: auto !important;
  }
}
</style>